import React from 'react';

// Fixed background system: violet mesh + luminous waves + orbs + grain
export default function SimnopsisBackground() {
  return (
    <div className="simnopsis-bg" aria-hidden="true">
      {/* Ambient glow orbs */}
      <div className="bg-orb bg-orb-1" />
      <div className="bg-orb bg-orb-2" />
      <div className="bg-orb bg-orb-3" />

      {/* Luminous waves */}
      <svg
        className="wave-svg wave-1"
        viewBox="0 0 2200 900"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="glow-blur-12">
            <feGaussianBlur stdDeviation="12" />
          </filter>
          <filter id="glow-blur-3">
            <feGaussianBlur stdDeviation="3" />
          </filter>
        </defs>
        {/* Wave 1 — upper violet, glow layer */}
        <path
          d="M0,315 Q275,215 550,315 T1100,315 T1650,315 T2200,315"
          fill="none"
          stroke="#A98CF5"
          strokeOpacity="0.45"
          strokeWidth="8"
          filter="url(#glow-blur-12)"
        />
        {/* Wave 1 — crisp */}
        <path
          d="M0,315 Q275,215 550,315 T1100,315 T1650,315 T2200,315"
          fill="none"
          stroke="#C4B0FA"
          strokeOpacity="0.55"
          strokeWidth="1.5"
          filter="url(#glow-blur-3)"
        />
      </svg>

      <svg
        className="wave-svg wave-2"
        viewBox="0 0 2200 900"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="glow-blur-12b">
            <feGaussianBlur stdDeviation="12" />
          </filter>
          <filter id="glow-blur-3b">
            <feGaussianBlur stdDeviation="3" />
          </filter>
          <filter id="glow-blur-15">
            <feGaussianBlur stdDeviation="15" />
          </filter>
        </defs>
        {/* Wave 2 — lower cyan, glow */}
        <path
          d="M0,585 Q330,485 660,585 T1320,585 T1980,585 T2200,585"
          fill="none"
          stroke="#20B8F2"
          strokeOpacity="0.35"
          strokeWidth="7"
          filter="url(#glow-blur-12b)"
        />
        {/* Wave 2 — crisp */}
        <path
          d="M0,585 Q330,485 660,585 T1320,585 T1980,585 T2200,585"
          fill="none"
          stroke="#7CD5FA"
          strokeOpacity="0.45"
          strokeWidth="1.4"
          filter="url(#glow-blur-3b)"
        />
        {/* mint ghost */}
        <path
          d="M0,605 Q330,505 660,605 T1320,605 T1980,605 T2200,605"
          fill="none"
          stroke="#7EE06D"
          strokeOpacity="0.14"
          strokeWidth="6"
          filter="url(#glow-blur-15)"
        />
      </svg>

      <svg
        className="wave-svg wave-3"
        viewBox="0 0 2200 900"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Faint detail thread */}
        <path
          d="M0,450 Q400,400 800,450 T1600,450 T2200,450"
          fill="none"
          stroke="#C4B0FA"
          strokeOpacity="0.20"
          strokeWidth="1.0"
        />
      </svg>

      <div className="grain-overlay" />
    </div>
  );
}
